<template>
  <div>
    <b-row class="mb-1">
      <b-col
        lg="6"
        md="6"
        sm="12"
      >
        <div class="d-flex align-items-center">
          <b-link
            style="font-size: 26px; color: #fff;"
            :to="{ path: `/crosswalk-sub?DeptID=${deptid}`}"
          >
            <feather-icon
              style="margin-bottom: 5px;"
              size="26"
              icon="ArrowLeftIcon"
            /><span style="color: #00FF80;"> ทางข้ามถนนอัจฉริยะ : </span>{{ detail }}
          </b-link>
          <a
            :href="anydesk"
            class="large-dropdown ml-1 ms-3"
          >
            <b-button
              size="sm"
              variant="outline-danger"
            ><b-img
              src="@/assets/images/logo/anydesk.png"
              style="height: 16px; width: 16px;"
            />
            <!-- <span style="color:#fff;"> {{ anydesk1 }}</span> -->
            </b-button>
          </a>
        </div>
      </b-col>
      <b-col
        lg="6"
        md="6"
        sm="12"
        class="text-right"
      >
        <b-button
          v-b-modal="'modalCrosswalk'"
          variant="outline-info"
          style="font-size: 16px; color: #fff; background-color: rgba(60, 149, 200, 0.5);"
          title="ตารางข้อมูล"
        >
          <span style="color: #55ffff; text-shadow: 0 0 6px #000000;"> ข้อมูลการฝ่าฝืนสัญญาณไฟ </span>
        </b-button>

        <b-button
          class="ml-1"
          variant="outline-danger"
          style="font-size: 16px; color: #fff; background-color: #000000;"
        >
          <span style="color: #fff; text-shadow: 0 0 2px #fff; margin-right: 5px;"> ฝ่าฝืนทางข้าม </span>
          <span style="color: #ff5252; text-shadow: 0 0 6px #ff0000; font-size: 18px;">{{ Unbutton.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</span>
          <span style="color: #fff; text-shadow: 0 0 2px #fff; margin-left: 5px;"> คน </span>
        </b-button>
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col
        lg="5"
        md="12"
        sm="12"
      >
        <b-row class="match-height">
          <b-col lg="12">
            <l-map
              ref="mymap"
              :min-zoom="minZoom"
              :crs="crs"
              style="width: 100%; height: 350px; border: 2px solid #000; border-radius: 10px 10px 10px 10px;"
              :options="{scrollWheelZoom:false, zoomControl: false, attributionControl:false, doubleClickZoom: false, touchZoom: false, boxZoom: false, keyboard: false, dragging: false,
              }"
              @ready="onMapReady"
            >
              <l-image-overlay
                :url="require('@/assets/images/crossWalk/roadnewred.gif')"
                :bounds="imageBounds"
              />
              <!-- <l-tile-layer :url="url" /> -->
              <l-marker
                v-for="(marker, index) in markers"
                :key="'marker'+index"
                :ref="'marker'+index"
                :lat-lng="[marker.Latitude, marker.Longtitude]"
                :options="{ autoClose: false, closeOnClick: false }"
                @click="stream(marker.RTSP_HLS, marker.Camera_Desc)"
              >
                <l-icon
                  :icon-size="[28, 40]"
                  :icon-anchor="[16, 37]"
                  :icon-url="require('@/assets/images/icons/MakerCCTV.svg')"
                />
                <!-- <l-popup
                  ref="popup"
                >
                  <div>
                    <span style="color:white; padding: 1px; text-align: left; font-size:14px;">
                      ตำแหน่ง:
                    </span>
                    <video
                      id="video"
                      style="width:250px; height:auto; flex-direction: row;"
                      muted
                      autoplay
                      playsinline
                    />
                  </div>
                </l-popup> -->
              </l-marker>
            </l-map>
          </b-col>
          <b-col lg="12">
            <br>
            <CrosswalkScifiRTSP />
          </b-col>
        </b-row>
      </b-col>

      <!-- ส่วนต่าง ๆ -->
      <b-col lg="7">
        <div>
          <b-row v-if="checkcam <= 2"> <!-- ไม่มีนับรถ -->
            <b-col lg="12">
              <CrosswalkScifiStatisticsNoCar />
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col lg="12">
              <CrosswalkScifiStatistics />
            </b-col>
          </b-row>
        </div>

        <div>
          <b-row v-if="checkcam <= 2"> <!-- ไม่มีนับรถ -->
            <b-col lg="12">
              <CrosswalkScifiSpeedLineChartNoCar />

            </b-col>
          </b-row>
          <b-row v-else>
            <b-col lg="12">
              <CrosswalkScifiSpeedLineChart />
              <CrosswalkScifiTrendLineChart />

            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <ModalCrosswalkTable />
  </div>
</template>

<script>
/* eslint-disable global-require */
import Hls from 'hls.js'
import {
  BRow, BCol, BLink, BButton, BImg,
} from 'bootstrap-vue'
import {
  LMap, LMarker, LIcon, LImageOverlay,
  // LPopup, LTileLayer,
} from 'vue2-leaflet'
import axios from '@axios'
import { Icon, CRS } from 'leaflet'
import CrosswalkScifiStatistics from './CrosswalkScifiStatistics.vue'
import CrosswalkScifiStatisticsNoCar from './CrosswalkScifiStatisticsNoCar.vue'
import CrosswalkScifiRTSP from './CrosswalkScifiRTSP.vue'
import CrosswalkScifiSpeedLineChart from './CrosswalkScifiSpeedLineChart.vue'
import CrosswalkScifiSpeedLineChartNoCar from './CrosswalkScifiSpeedLineChartNoCar.vue'
import CrosswalkScifiTrendLineChart from './CrosswalkScifiTrendLineChart.vue'
import ModalCrosswalkTable from '@/views/crosswalkscifi/detail/ModalCrosswalkTable.vue'
import 'leaflet/dist/leaflet.css'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
/* eslint-disable global-require */
export default {
  components: {
    BRow,
    BCol,
    BLink,
    BButton,
    BImg,
    LMap,
    // LTileLayer,
    LMarker,
    LIcon,
    LImageOverlay,
    // LPopup,
    CrosswalkScifiStatistics,
    CrosswalkScifiStatisticsNoCar,
    CrosswalkScifiRTSP,
    CrosswalkScifiSpeedLineChart,
    CrosswalkScifiSpeedLineChartNoCar,
    CrosswalkScifiTrendLineChart,

    ModalCrosswalkTable,
  },
  data() {
    return {
      url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png',
      // url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      imageBounds: [[0, 0], [0, 0]],
      zoom: 0,
      minZoom: -100,
      crs: CRS.Simple,
      // center: [0, 0],
      deptid: '',
      detail: '',
      markers: [],
      checkcam: '',
      anydesk: '',
      userData: JSON.parse(localStorage.getItem('userData')),

      Unbutton: '',
    }
  },
  created() {
  },
  mounted() {
    this.checkCam()
    this.getdetailCrossWalk()
    this.getDataCrosswalkScifi()
    this.interval = setInterval(() => {
      this.checkCam()
      this.getdetailCrossWalk()
      this.getDataCrosswalkScifi()
    }, 300000)
  },
  methods: {
    // getMarker() {
    //   axios
    //     .post('https://drrweb-api.firsttech.co.th/get-Station-WIM', { wid: this.$route.query.wid })
    //     .then(response => {
    //       this.center = []
    //       this.markers = response.data
    //       this.center.push(this.markers[0].Latitude)
    //       this.center.push(this.markers[0].Longtitude)
    //       this.waydetail = response.data[0].StationDescription
    //       this.deptid = response.data[0].Deptid
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     })
    // },
    checkCam() {
      axios
        .post('/checkCamCrossWalk', { wid: this.$route.query.wid })
        .then(response => {
          this.checkcam = response.data[0].check_cam
          console.log(this.countPhase)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getdetailCrossWalk() {
      axios
        .post('/detailCrossWalk', { wid: this.$route.query.wid })
        .then(response => {
          // this.pj_id = response.data[0].pj_id
          this.deptid = response.data[0].deptid
          this.detail = response.data[0].detail
          this.anydesk = `anydesk:${response.data[0].anydesk}`
        })
        .catch(error => {
          console.log(error)
        })
    },
    stream(value, camdesc) {
      setTimeout(() => {
        this.camdesc = camdesc
        const hls = new Hls({
          lowLatencyMode: true,
          autoreconnect: true,
        })
        const stream = value
        const video = document.querySelector('#video')
        hls.loadSource(stream)
        hls.attachMedia(video)
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
        hls.on(Hls.Events.ERROR, () => {
          video.play()
        })
      }, 500)
    },

    onMapReady(mapObject) {
      // Get the size of the map container
      const mapSize = mapObject.getSize()

      // Calculate the bounds to fit the image to the map
      const southWest = mapObject.unproject([0, mapSize.y], mapObject.getZoom())
      const northEast = mapObject.unproject([mapSize.x, 0], mapObject.getZoom())

      // Update the imageBounds
      this.imageBounds = [southWest, northEast]

      // Fit the map to these bounds
      mapObject.fitBounds(this.imageBounds)
    },
    // ... other methods ...

    getDataCrosswalkScifi() {
      axios.post('/valueCrossWalk', { wid: this.$route.query.wid })
        .then(response => {
          this.Unbutton = response.data[0].Unbutton
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.leaflet-popup-content {
    margin: 10px 10px;
    width: 250px;
    height: 100%;
  }
  .leaflet-container a.leaflet-popup-close-button {
    padding: 0 0 0 0
  }
.leaflet-popup-content-wrapper,
.leaflet-popup-tip {
    background: rgba(36, 36, 36, 0.95);
    box-shadow: 0 3px 14px rgba(0,0,0,0.4);
    /* Green */
    border: 1px solid #00B058;
    border-radius: 12px 12px 12px 12px;
}
.large-dropdown .dropdown-menu {
  min-width: 100px; /* Adjust width as needed */
  font-size: 12px; /* Smaller font size */
  padding: 5px; /* Smaller padding */
}
.large-dropdown .btn {
  padding: 0.25rem 0.5rem; /* Smaller button padding */
  font-size: 0.875rem; /* Smaller text on the dropdown button */
}
</style>
